import { useState, useEffect, useRef } from "react";
import moment from "moment";
import {
  getAllOrder,
  getAllAdminOrder,
} from "../../../store/actions/orderActionCreators";
import { getUserFromStorage } from "../../../util/localStorage.util";
import { ListOrdersPayloadDto } from "../../../store/actions/dtos/ListOrdersPayloadDto";

const storageInfo = getUserFromStorage();

const defaultPayload: ListOrdersPayloadDto = {
  PageNumber: 1,
  PageSize: 20,
  OrderStartDate: "",
  OrderEndDate: "",
  ShipStartDate: "",
  ShipEndDate: "",
  OrderBy: "",
  SearchBySoNo: "",
  SearchByPoNo: "",
  SearchByMeycoNo: "",
  SearchByJobTitle: "",
  SearchByGroups: "",
};

export function useOrderList() {
  const [loading, setLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [listOrdersPayload, setListOrdersPayload] =
    useState<ListOrdersPayloadDto>(defaultPayload);
  const cancelFetchRef = useRef<(() => void) | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getOrderList(defaultPayload);
  }, []);

  async function getOrderList(payload: ListOrdersPayloadDto) {
    cancelFetchRef.current?.();
    let cancelled = false;
    cancelFetchRef.current = () => {
      cancelled = true;
    };
    setLoading(true);
    const [response, err]: Array<any> = storageInfo
      ? JSON.parse(storageInfo).isAdmin
        ? await getAllAdminOrder(payload)
        : await getAllOrder(payload)
      : await getAllOrder(payload);
    if (cancelled) return;
    if (response && response.data.length > 0) {
      setTotalPage(response.totalRecords);
      setTableData(
        response.data.map((customer: any) => ({
          key: customer.sn,
          sn: customer.sn,
          soNo: customer.soNo,
          poNo: customer.poNo,
          meycoNo: customer.meycoNo,
          jobName: customer.jobName,
          orderDate: moment(customer.orderDate).format("YYYY-MM-DD"),
          shippingDate: moment(customer.shippingDate).format("YYYY-MM-DD"),
          status: customer.orderStatus,
          orderType: customer.orderType,
          orderDescription: customer.orderStatus,
          file: customer,
          tracking: customer.trackingNo,
          isPayButton: customer.allowPayButton,
          customer: customer,
          allowUpdates: customer.allowUpdates,
        }))
      );
      setLoading(false);
      return;
    }
    setTableData([]);
    setLoading(false);
    if (err) {
      setTableData([]);
      setLoading(false);
    }
  }

  const handleTableChange = (pagination: any, _filters: any, sorter: any) => {
    const orderBy = sorter.column ? sorter.field : "";
    let orderDirection = "";
    if (sorter.column) {
      orderDirection = sorter.order === "descend" ? "desc" : "asc";
    }
    const payload = {
      ...listOrdersPayload,
      OrderBy: `${orderBy} ${orderDirection}`,
      PageNumber: pagination.current,
      PageSize: pagination.pageSize ?? listOrdersPayload.PageSize,
    };
    setListOrdersPayload(payload);
    getOrderList(payload);
  };

  return {
    loading,
    tableData,
    totalPage,
    listOrdersPayload,
    setListOrdersPayload,
    getOrderList,
    handleTableChange,
  };
}
